import { useEffect, useState } from "react";
import api from "../lib/api";
import { ShieldCheck } from "lucide-react";

const COLS = [["jobs", "Zakázky"], ["prices", "Ceníky"], ["budgets", "Rozpočty"], ["invoices", "Faktury"], ["reports", "Reporty"], ["team", "Tým"], ["settings", "Nastavení"]];

export function RolesTable() {
    const [roles, setRoles] = useState([]);
    useEffect(() => { api.get("/team/roles").then((r) => setRoles(r.data)).catch(() => {}); }, []);
    if (!roles.length) return null;
    return (
        <div className="bg-white border border-slate-200 mt-8" data-testid="roles-table">
            <div className="px-6 py-4 border-b-2 border-slate-900 flex items-center gap-2">
                <ShieldCheck className="w-4 h-4 text-orange-600" />
                <div>
                    <div className="font-display font-bold uppercase tracking-wider text-sm">Role a oprávnění</div>
                    <div className="text-xs text-slate-500">Co která role v aplikaci vidí a smí. Role členům přiděluje vlastník na stránce Tým firmy.</div>
                </div>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full text-xs">
                    <thead>
                        <tr className="text-left text-[10px] uppercase tracking-widest text-slate-500 border-b border-slate-200">
                            <th className="px-4 py-3 font-semibold">Role</th>
                            {COLS.map(([k, l]) => <th key={k} className="px-4 py-3 font-semibold">{l}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {roles.map((r) => (
                            <tr key={r.key} className="border-b border-slate-100 align-top" data-testid={`role-row-${r.key}`}>
                                <td className="px-4 py-3 min-w-[160px]">
                                    <div className="font-bold text-slate-900 text-sm">{r.label}</div>
                                    <div className="text-slate-500 mt-1">{r.description}</div>
                                </td>
                                {COLS.map(([k]) => {
                                    const v = r.permissions[k] || "—";
                                    const no = v === "ne";
                                    return <td key={k} className={`px-4 py-3 ${no ? "text-slate-400" : "text-slate-700"}`}>{no ? "✕ ne" : v === "vše" || v === "ano" ? `✓ ${v}` : v}</td>;
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
